import floralStyling from '../assets/supplier-covers/floral-styling.webp'
import photoVideo from '../assets/supplier-covers/photo-video.webp'
import services from '../assets/supplier-covers/services.webp'
import venue from '../assets/supplier-covers/venue.webp'

const covers = new Map<string, string>([
  ['venue', venue],
  ['accommodation', venue],
  ['photographer', photoVideo],
  ['videographer', photoVideo],
  ...[
    'cake-sweets',
    'florist',
    'decor',
    'stationery',
    'hair',
    'makeup',
    'bride-attire',
    'groom-attire',
    'rings',
  ].map((category): [string, string] => [category, floralStyling]),
])

export function supplierCoverImage(category: string) {
  return covers.get(category) ?? services
}
